const state = () => ({
    standAloneProgressNoteSaved: false,
    inboxMessageRead: false
  })
  
  // getters
  const getters = {
    getStandAloneProgressNote(state, getters) {
      return state.standAloneProgressNoteSaved
    }
  }
  
  // actions
  const actions = {
  }
  
  // mutations
  const mutations = {
    standAloneProgressNoteSaved(state, payload) {
      state.standAloneProgressNoteSaved = !state.standAloneProgressNoteSaved
    },
    inboxMessageRead(state, payload) {
      state.inboxMessageRead = !state.inboxMessageRead
    }
  }
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }